import { EPlanDisplayMode, EPlanStatus, ESeriesCategory, ESIMCardStatus, ICloudService, IPlan, IReoSelectOption, IUserAddresses } from '@reolink-cloud/interface';
import { countriesManager, productsManager } from '@/lib';
import { IComboCardProps } from '../SeriesCombo';

/**
 * 构造国家选项
 * @returns 按A-Z排序的选项
 */
export const generateCountryOptions = (): IReoSelectOption[] => {

    const options: IReoSelectOption[] = [];
    const availableCountryList = productsManager.getAvailableCountryList();
    for ( const countryCode of availableCountryList ) {

        const countryInfo = countriesManager.getSingleCountryInfo( countryCode );

        options.push({
            label: countryInfo.text,
            value: countryInfo.code,
            id: countryInfo.code,
        });

    }

    options.sort(( a, b ) => a.label.localeCompare( b.label ));

    return options;

};

/**
 * 获取应该搜索的legacy系列
 *  - 当前套餐没有被禁用，使用当前套餐的legacy系列
 *  - 当前套餐被禁用时
 *      - 填写了 portable 套餐，显示portable套餐的legacy系列
 *          - portable被禁用或者renew-only时，显示最新的套餐
 *      - portable套餐没填的时候为'0'，显示最新的套餐
 */
export const getLegacyTag = async ( planInfo: IPlan, currentSubTag: string  ): Promise<string> => {

    const portablePlanId = planInfo.portablePlan;

    let legacyTag = '';

    if ( planInfo.status === EPlanStatus.DISABLED ) {

        if ( portablePlanId !== '0' ) { // 填写了 portable 套餐

            const portablePlanDetails = await productsManager.getPlanById( portablePlanId );
            const seriesDetails = productsManager.getPlanSeriesByKey( portablePlanDetails.seriesKey );

            if ( portablePlanDetails.status !== EPlanStatus.ENABLED ||
                    !portablePlanDetails.limitations.switchFromOther ) {

                // 一个disable的套餐的portable套餐也被disable或者renew-only的时候，显示最新的套餐
                legacyTag = '';

            } else { // 使用 portable 套餐的legacy系列

                legacyTag = seriesDetails.legacyTag ?? '';

            }

        } else {

            // portable套餐没填的时候为'0'，显示最新的套餐
            legacyTag = '';

        }

    } else { // 当前套餐没有被禁用，使用当前套餐的legacy系列

        legacyTag = currentSubTag;

    }

    return legacyTag;

};

/** 当前订阅是否可以切换套餐 */
export const getIsSwitchAble = ( sub?: ICloudService ): boolean => {

    if ( !sub ) {

        return false;

    }
    /**
     * 当nextSwitchableAt === 0 或者 当前时间小于nextSwitchableAt时间戳时，允许切换
     */
    if ( sub.nextSwitchableAt === 0 || new Date().getTime() > sub.nextSwitchableAt ) {

        return true;

    } else {

        return false;

    }

};

/** 根据默认地址选择国家，优先级：billing address > shipping address > 账户中心国家 */
export const handleDefaultAddressCountry = ( userAddresses: IUserAddresses ): string|undefined => {

    if ( userAddresses.billingInfos.length > 0 ) {

        return userAddresses.billingInfos[0].country;

    }
    if ( userAddresses.shippingInfos.length > 0 ) {

        return userAddresses.shippingInfos[0].country;

    }
    return undefined;

};

export const getComboCardList = ( currentPlanDisplayMode: EPlanDisplayMode, isAddOn: boolean, SIMCardStatus: ESIMCardStatus ): IComboCardProps[] => {

    if ( isAddOn ) {

        return [{
            key: ESIMCardStatus.ACTIVE,
            isExpand: true,
            isShowSelect: true,
            type: ESeriesCategory.CLOUD_DATA_ADD_ON_PLAN
        }];

    }
    if ( currentPlanDisplayMode === EPlanDisplayMode.VIEW ) {

        return [{
            key: ESIMCardStatus.ACTIVE,
            isExpand: true,
            isShowSelect: false,
            type: ESeriesCategory.CLOUD_STORAGE_DATA_PLAN
        }, {
            key: ESIMCardStatus.UNKNOWN,
            isExpand: false,
            isShowSelect: false,
            type: ESeriesCategory.CLOUD_STORAGE_PLAN
        }, {
            key: 'addon',
            isExpand: false,
            isShowSelect: false,
            type: ESeriesCategory.CLOUD_DATA_ADD_ON_PLAN
        }];

    } else {

        switch ( SIMCardStatus ) {

            case ESIMCardStatus.UNKNOWN: {

                return [{
                    key: ESIMCardStatus.UNKNOWN,
                    isExpand: true,
                    isShowSelect: true,
                    type: ESeriesCategory.CLOUD_STORAGE_PLAN
                }];

            }
            default: {

                return [{
                    key: ESIMCardStatus.ACTIVE,
                    isExpand: true,
                    isShowSelect: true,
                    type: ESeriesCategory.CLOUD_STORAGE_DATA_PLAN,
                }];

            }

        }

    }

};
